import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  fetchUserPermissionsMobile,
  postUserPermissionsMobile,
} from "../../../redux/api/admin.api";
import { PermissionsMobileDataInterface } from "../../../redux/interfaces/admin.interface";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";

import ContentCard from "../../../components/misc/ContentCard";
import useRoutesHelper from "../../../hooks/useRoutesHelper";
import Checkbox from "../../../components/misc/Checkbox";
import CustomButton from "../../../components/CustomButton";

function AdministrateUserMobileRoles() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { routeParams } = useRoutesHelper();

  const {
    admin: {
      permissionsMobile: { data: permissionsData, isLoadingPermissionsMobile },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  const { userId, firstName, secondName } = routeParams || {};

  const [permissions, setPermissions] = useState<
    PermissionsMobileDataInterface[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserPermissionsMobile(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    if (permissionsData && permissionsData.length > 0) {
      setPermissions(permissionsData);
    }
  }, [permissionsData]);

  const handleCheckPrimaryRoute = (routeId: number, checked: boolean) => {
    const newPermissions = permissions.map((permission) => {
      if (permission.idRoute === routeId) {
        return {
          ...permission,
          isChecked: checked,
        };
      }
      return permission;
    });
    setPermissions(newPermissions);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    const resultAction = await dispatch(
      postUserPermissionsMobile({
        userId,
        permissions: permissions,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postUserPermissionsMobile) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postUserPermissionsMobile) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };

  return (
    <ContentCard
      cardTitle={`Editeaza roluri pentru utilizatorul: ${secondName} ${firstName}`}
      isLoading={isLoadingPermissionsMobile}>
      {permissions.map((permission) => {
        return (
          <div key={permission.idRoute} className="d-flex mb-2 mr-2">
            <Checkbox
              label={permission.routeLabel}
              name={`${permission.idRoute}`}
              labelAlign="right"
              onChange={(checked) =>
                handleCheckPrimaryRoute(permission.idRoute, checked)
              }
              checked={permission.isChecked}
            />
          </div>
        );
      })}

      <div className="d-flex justify-content-between mt-4">
        <CustomButton variant="outlined" onClick={handleGoBack}>
          Anuleaza
        </CustomButton>
        <CustomButton
          type="submit"
          variant="contained"
          loading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}>
          Salveaza
        </CustomButton>
      </div>
    </ContentCard>
  );
}

export default AdministrateUserMobileRoles;
